import React, {useEffect, useState} from 'react';
import {NavLink} from "react-router-dom";
import {themeButtons} from "../../css/themeButtons";
import {Button} from "@material-ui/core";
import ContractTableRow from "../common/ContractTableRow/ContractTableRow";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";


const Contracts = (props) => {
    const {
        contracts, userRole, getObjectsList
    } = props


    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (type, newContactId) => {
        setAnchorEl(null);
    };


    useEffect(() => {
        if (userRole !== "MODERATOR") {
            getObjectsList()
        }
    }, [])


    const buttons = themeButtons()
    return (
        <div className="main">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-auto">
                        <Button fullWidth className={`btn ${buttons.btnWarn} mb-2`} onClick={handleClick}>
                            Образец договора
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => handleClose()}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <MenuItem component={NavLink} to="/lk/contracts/sample?type=percent"> Комиссионный</MenuItem>
                            <MenuItem component={NavLink} to="/lk/contracts/sample?type=subscriber"> Абонентский</MenuItem>
                        </Menu>
                    </div>




                </div>
                <div className="contract-table">
                    {contracts && Object.keys(contracts).map((item) => {
                        return <ContractTableRow key={contracts[item].id} contract={contracts[item]}/>

                    })}
                </div>

            </div>
        </div>

    )
}


export default Contracts;